import { firstValueFrom, Observable } from 'rxjs';
import { Component, HostBinding, Input, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { CommentPanelManagerService } from '../../services';

import {
  AuditorsFilter,
  CommentFilterOption,
  CommentFilterOptionDefinition,
  MentionedThreadsFilter,
} from '../../models';

@Component({
  selector: 'app-thread-state-filter',
  templateUrl: './thread-state-filter.component.html',
})
export class ThreadStateFilterComponent implements OnInit {
  @HostBinding('class')
  private readonly classes = 'flex flex-row gap-3 items-center';

  private get selectedValue(): CommentFilterOption {
    return this.control.value?.value;
  }

  @Input()
  showIcon = true;

  get isSelectExpanded(): boolean {
    return this.selectedValue === MentionedThreadsFilter || this.selectedValue === AuditorsFilter;
  }

  filterOptions$: Observable<CommentFilterOptionDefinition[]>;
  selectedFilterOption$: Observable<CommentFilterOptionDefinition>;
  displayValueSelector = this.selectDisplayValue.bind(this);
  readonly auditorsFilter = AuditorsFilter;
  readonly control = new FormControl();

  constructor(
    private translateService: TranslateService,
    private commentPanelManagerService: CommentPanelManagerService
  ) { }

  ngOnInit(): void {
    this.filterOptions$ = this.commentPanelManagerService.getFilterOptions();
    this.selectedFilterOption$ = this.commentPanelManagerService.getSelectedFilterOption();
  }

  async selectOption(selectedFilterOption: CommentFilterOptionDefinition): Promise<void> {
    const currentOption = await firstValueFrom(this.selectedFilterOption$);
    const isOptionChanged = currentOption?.value !== selectedFilterOption.value;

    if (isOptionChanged) {
      this.commentPanelManagerService.setFilterOption(selectedFilterOption);
      this.control.setValue(selectedFilterOption, { emitEvent: false });
    } else if (!this.control.value) {
      this.control.setValue(selectedFilterOption, { emitEvent: false });
    }
  }

  private selectDisplayValue(opt: CommentFilterOptionDefinition): string {
    return this.translateService.instant(opt.translationKey);
  }
}
